import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu       from '@material-ui/core/Menu';
import MenuItem   from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import ListItemIcon      from '@material-ui/core/ListItemIcon';
import MoreVertIcon      from '@material-ui/icons/MoreVert';
import PlaylistAddIcon   from '@material-ui/icons/PlaylistAdd';
import PrintDisabledIcon from '@material-ui/icons/PrintDisabled';
import PrintIcon         from '@material-ui/icons/Print';

import { create } from '../util';

export default function ScheduleMenu(props) {
  const [ anchorEl, setAnchorEl ] = useState(null);

  const { path, setNewSchedule, setPath } = props.context.getStates();

  return (<>
    <IconButton color="inherit"
      onClick={(event => { setAnchorEl(event.currentTarget); })}
    ><MoreVertIcon /></IconButton>

    <Menu open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      keepMounted
      onClose={(event) => { setAnchorEl(null); }}
    >
      {path === '/schedules' && (
        <MenuItem onClick={(event) => {
          setNewSchedule(create.schedule(-1));
          setAnchorEl(null);
        }}>
          <ListItemIcon>
            <PlaylistAddIcon />
          </ListItemIcon>
          <Typography variant="inherit">{'새 일정 등록'}</Typography>
        </MenuItem>
      )}

      {path === '/schedules' && (
        <MenuItem onClick={(event) => {
          setPath('/schedules/print');
          setAnchorEl(null);
        }}>
          <ListItemIcon>
            <PrintIcon />
          </ListItemIcon>
          <Typography variant="inherit">{'인쇄'}</Typography>
        </MenuItem>
      )}

      {path === '/schedules/print' && (
        <MenuItem onClick={(event) => {
          setPath('/schedules');
          setAnchorEl(null);
        }}>
          <ListItemIcon>
            <PrintDisabledIcon />
          </ListItemIcon>
          <Typography variant="inherit">{'인쇄 취소'}</Typography>
        </MenuItem>
      )}
    </Menu>
  </>);
}